import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/navigation/styles.scss';export default {
  "navigation": "_navigation_ao3fh_1"
};